'use strict';

var AUTH_EVENTS = {
  notAuthenticated: 'auth-not-authenticated',
  notAuthorized: 'auth-not-authorized'
};

module.exports = AUTH_EVENTS;
